import { makeContextModule } from '@cian/react-utils';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

export interface IHoveredOfferContext {
  hoveredOffer: IOfferForDesktopEnrichedV3Schema | undefined;
}

export const {
  Context: { Provider: HoveredOfferContextProvider },
  useContext: useHoveredOfferContext,
} = makeContextModule<IHoveredOfferContext>({
  contextName: 'HoveredOfferContext',
});

export interface IHoveredOfferActionsContext {
  onOfferHover: (offer: IOfferForDesktopEnrichedV3Schema) => void;
  onOfferBlur: VoidFunction;
}

export const {
  Context: { Provider: HoveredOfferActionsContextProvider },
  useContext: useHoveredOfferActionsContext,
} = makeContextModule<IHoveredOfferActionsContext>({
  contextName: 'HoveredOfferActionsContext',
});
